import { render, staticRenderFns } from "./addFlashSaleGoods.vue?vue&type=template&id=5dafe88c&scoped=true&"
import script from "./addFlashSaleGoods.vue?vue&type=script&lang=js&"
export * from "./addFlashSaleGoods.vue?vue&type=script&lang=js&"
import style0 from "./addFlashSaleGoods.vue?vue&type=style&index=0&id=5dafe88c&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dafe88c",
  null
  
)

export default component.exports